export const keyWiseSettingsRouteMapping = {
	roles: 'roles',
	users: 'users',
	staff: 'staff',
	'import-data': 'import-data',
};

export const keyWiseConfigurationRouteMapping = {
	company: 'company',
	'branch code': 'branch-code',
	'category code': 'category-code',
	departments: 'department',
	'job grade': 'job-grade',
	'pay point': 'pay-point',
	'cost center': 'cost-center',
	'job title': 'job-title',
	// earning: 'earning',
	// deduction: 'deduction',
	'leave management': 'leave-management',
	holidays: 'holidays',
};

export const keyWisePayrollSettingsRouteMapping = {
	'company setup': 'company-setup',
	'pay period': 'pay-period',
	'statutory components': 'statutory-components',
	'pay schedule': 'pay-schedule',
	'earnings code': 'earning-code',
	'deduction code': 'deduction-code',
	'mid-month pay setup': 'mid-month-pay',
	'payroll history': 'payroll-history',
};
export const keyWiseApprovalRouteMapping = {
	employee: 'employee',
};

export const employeeFieldsMapping = {
	firstName: 'First Name',
	lastName: 'Last Name',
	dob: 'Date Of Birth',
	country: 'Country',
	ssn: 'SSN',
	passportNo: 'Passport No',
	nationalRegistrationNo: 'National Registration No',
	joiningDate: 'Joining Date',
	recordStatus: 'Record Status',
	staffCode: 'Staff Code',
};

export const notificationConfigMapping: any = {
	EMPLOYEE: 'Employee',
	PAYROLL_RUN: 'Payroll Run',
	LOAN: 'Loan',
	TIME_ACTIVITIES: 'Time Activities',
};
